import { useEffect, useRef } from "react";

function HandritBookView(props) {
	const iframeRef = useRef();

	const windowMessageHandler = (event) => {
	};

	useEffect(() => {
		window.addEventListener('message', windowMessageHandler);

		return () => {
			window.removeEventListener('message', windowMessageHandler);
		}
	}, []);

	return <iframe ref={iframeRef} allowFullScreen="allowfullscreen"
		frameBorder="0"
		height="800"
		mozallowfullscreen="mozallowfullscreen"
		msallowfullscreen="msallowfullscreen"
		oallowfullscreen="oallowfullscreen"
		scrolling="no"
		src={props.src}
		webkitallowfullscreen="webkitallowfullscreen"
		width="100%">
	</iframe>
};

export default HandritBookView;